import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

// TODO Remove these props and just style with style/class
const StyledIcon = styled(BaseSvg)`
  width: ${({ width }: any) => width + 'px'};
  height: ${({ height }: any) => height + 'px'};
  color: ${({ fill }: any) => fill};
`

// TODO Use currentColor and leave the "white" white (or don't fill)
const Warning = ({
  title = 'Warning',
  fill = '#FFA200',
  width = 20,
  height = 20,
  ...rest
}: IconProps & { fill?: string; width?: number; height?: number; backgroundColor?: string }) => (
  // @ts-expect-error
  <StyledIcon viewBox="0 0 64 64" width={width} height={height} title={title} fill={fill} {...rest}>
    <rect data-element="frame" width={64} height={64} rx={3} ry={3} fill="currentColor" />
    <g fill="#ffffff" transform="matrix(.6 0 0 .6 12.8 12.8)">
      <path d="M34 44h-4L28 3h8z" />
      <circle data-color="color-2" cx={32} cy={56} r={5} />
    </g>
  </StyledIcon>
)

Warning.displayName = 'Warning'
Warning.needsWork = true
export default Warning
